import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import Common from './common'
import Provider from './provider'
import Endpoint from './endpoint'
import Estimate from './estimate'
import Estimation from './estimation'
import Order from './order'
import ClientOrder from './clientOrder'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  getters: {
  },
  actions: {
  },
  modules: {
    common: Common,
    provider: Provider,
    endpoint: Endpoint,
    estimate: Estimate,
    estimation: Estimation,
    order: Order,
    clientOrder: ClientOrder
  },
  plugins: [(new VuexPersistence({
    storage: window.localStorage
  })).plugin]
})
